import React from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
import { LinkedinShareButton, TwitterShareButton, EmailShareButton, LinkedinIcon, TwitterIcon, EmailIcon } from 'react-share';
import { createMarkup, utcDateToFormat } from './../../../../utils/helpers';
import './Detail.css';

const Detail = props => {
    const { publishedDate, title, publisher, body, externalLink, thumbnail, images } = props.data;
    let poster = images && images[0] && !thumbnail ? images[0] : thumbnail;

    if (poster) {
        poster = `${process.env.RAZZLE_ASSET_URL}${poster}`;
    }
    const formatDate = utcDateToFormat(publishedDate, 'MMMM DD, YYYY');
    const shareUrl = props.serverURL;
    const shareBody = body.replace(/<[^>]+>/g, '');

    const printerPage = () => {
        return window.print();
    };

    return (
        <section className="section news-body">
            <Helmet>
                <meta property="og:title" content={title} />
                <meta property="og:type" content="article" />
                <meta property="og:image" content={poster} />
                <meta name="description" property="og:description" content={shareBody} />
            </Helmet>
            <div className="container">
                <div className="columns">
                    <div className="column is-1 is-hidden-print">
                        <div className="share-container">
                            <div className="network">
                                <div role="link" tabIndex={0} onClick={printerPage} onKeyUp={printerPage}>
                                    <div className="custom-network">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32" version="1.1" width="32" height="32">
                                            <g>
                                                <rect width="32" height="32" fill="#7f7f7f" />
                                            </g>
                                            <g>
                                                <path
                                                    fill="white"
                                                    d="M24.67 10.62h-2.86V7.49H10.82v3.12H7.95c-.5 0-.9.4-.9.9v7.66h3.77v1.31L15 24.66h6.81v-5.44h3.77v-7.7c-.01-.5-.41-.9-.91-.9zM11.88 8.56h8.86v2.06h-8.86V8.56zm10.98 9.18h-1.05v-2.1h-1.06v7.96H16.4c-1.58 0-.82-3.74-.82-3.74s-3.65.89-3.69-.78v-3.43h-1.06v2.06H9.77v-3.58h13.09v3.61zm.75-4.91c-.4 0-.72-.32-.72-.72s.32-.72.72-.72c.4 0 .72.32.72.72s-.32.72-.72.72zm-4.12 2.96h-6.1v1.06h6.1v-1.06zm-6.11 3.15h6.1v-1.06h-6.1v1.06z"
                                                />
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div className="network">
                                <EmailShareButton url={shareUrl} subject={title} body={shareBody}>
                                    <EmailIcon size={32} iconBgStyle={{ fill: '#585858' }} round={false} />
                                </EmailShareButton>
                            </div>
                            <div className="network">
                                <LinkedinShareButton url={shareUrl} title={title} description={shareBody} windowWidth={660} windowHeight={460}>
                                    <LinkedinIcon size={32} round={false} />
                                </LinkedinShareButton>
                            </div>
                            <div className="network">
                                <TwitterShareButton url={shareUrl} title={title} windowWidth={660} windowHeight={460}>
                                    <TwitterIcon size={32} round={false} />
                                </TwitterShareButton>
                            </div>
                        </div>
                    </div>
                    <div className="column is-10">
                        {publishedDate && <div className="publish-date">{formatDate}</div>}
                        {publisher && <div className="publisher">{publisher}</div>}
                        {title && <h1 className="news-title">{title}</h1>}
                        {title && <div className="border-yellow" />}
                        {body && <div className="description" dangerouslySetInnerHTML={createMarkup(body)} />}
                        {externalLink && (
                            <a href={externalLink} target="_blank" rel="noopener noreferrer" className="read-more">
                                <span>READ FULL ARTICLE HERE</span>
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

Detail.propTypes = {
    data: PropTypes.object,
    serverURL: PropTypes.string,
};

export default Detail;
